<div
  [ngClass]="componentClass"
  [ngStyle]="componentStyle"
  [attr.aria-label]="identity">

  <span *ngIf="initials" class="se-avatar__initials">
    {{ initials }}
  </span>
</div>